import { Injectable } from '@angular/core';
import {
	MatterChicagoTitleInsurance,
	SubmitData,
} from '@models/title-insurance/chicago';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterRepo } from '@repos/matter/matter.repo';
import { SelectedMatter } from '@state/matter/matter.selectors';

@Injectable({
	providedIn: 'root',
})
export class UpdateChicagoService {
	@SelectSnapshot(SelectedMatter.getTitleInsurance)
	titleInsurance: MatterChicagoTitleInsurance;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(private matterRepo: MatterRepo) {}

	async updateChicagoData(
		fileNumber: number,
		prevPayload: SubmitData,
	): Promise<void> {
		const titleInsurance: MatterChicagoTitleInsurance = {
			...this.titleInsurance,
			firm: prevPayload.Firm,
			thirdPartyId: fileNumber,
			previousSubmittedPayload: prevPayload,
		};

		await this.matterRepo.Update(this.matterId, {
			titleInsurance,
		});
	}
}
